import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import type { SubscriptionSearchItem } from '../../@types/AdvertismentSubscription';
import LazyImage from '../../components/lazy/Image';
import Link from '../../components/link';
import type { ParsedList } from '../../models/list';
import type { RootState } from '../../reducers';
import { getListItemHitCount } from '../../selectors/list';
import { Skeleton } from '../../styled-components/components/Skeleton';
import { getPrenumerationSubscriptionByReferenceId } from '../../utils/reselectors';

interface SelectedCategoryProps {
  listItem: ParsedList;
  index: number;
}

const SelectedCategory = ({ listItem, index }: SelectedCategoryProps) => {
  const { t } = useTranslation(['common', 'startpage']);

  const listId = listItem?.id;
  const hits = useSelector<RootState, number | null>((s) => getListItemHitCount(s, listId));
  const isSubscribed = useSelector<RootState, SubscriptionSearchItem | null>((s) =>
    getPrenumerationSubscriptionByReferenceId(s, listId),
  );

  if (!listItem) return null;

  const { id, smallImage, slug, title } = listItem;

  const src = smallImage ? `url(${smallImage}?w=276&h=359)` : undefined;

  return (
    <div className="overflow-grid-item" key={id}>
      <div className="overflow-grid-content">
        <div data-wx-listcard="padding-small">
          {index > 5 ? (
            <LazyImage className="list-card-bg" src={src} />
          ) : (
            <div className="list-card-bg" style={{ backgroundImage: src }} />
          )}
          <Link
            to={`/${slug}`}
            title={t('Show the category', {
              ns: 'startpage',
              name: title,
            })}
            className="list-card"
          >
            <div className="list-card-header">
              {isSubscribed && (
                <div className="list-card-badge">
                  <i className="icon-heart no-margin" />
                </div>
              )}
            </div>
            <div className="list-card-footer">
              <div data-wx-label="light" />
              <div className="list-card-heading">{title}</div>
              <div className="list-card-sub-heading">
                {hits ? (
                  <div>
                    {t('Number of cars', {
                      ns: 'common',
                      count: hits || 0,
                    })}
                  </div>
                ) : (
                  <Skeleton $width="55px" $height="14px" />
                )}
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SelectedCategory;
